import React from 'react';
import LegalLayout from './legallayout';
import { Helmet } from 'react-helmet-async';

const Terms = () => (
  <LegalLayout title="Terms of Service" lastUpdated="April 3, 2026">

    <Helmet>
        <title>Terms of Service | Sitemanifest</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    <section>
      <h2 className="text-xl font-bold text-black mb-4">1. Agreement to Terms</h2>
      <p>
        By accessing or using Sitemanifest (the "Service"), operated by Sitemanifest ("we," "us," or "our"), 
        you agree to be bound by these Terms of Service. If you are entering into this agreement on behalf 
        of a business, you represent that you have the authority to bind that entity to these terms.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">2. Merchant of Record (Paddle)</h2>
      <p className="bg-gray-50 p-4 border-l-4 border-[#3EBAA2]">
        Our order process is conducted by our online reseller <strong>Paddle.com</strong>. 
        Paddle.com is the Merchant of Record for all our orders. Paddle handles all customer 
        service inquiries regarding payments and returns. By purchasing a subscription, 
        you also agree to Paddle’s terms and conditions.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">3. Description of Service</h2>
      <p>
        Sitemanifest provides a Reputation Firewall and Verified Registry Indexing service. 
        We offer tools for email-based review collection, manual review verification, 
        and SEO-optimized business profile hosting (the "Business Profiles").
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">4. Subscriptions and Payments</h2>
      <ul className="list-disc ml-6 space-y-2">
        <li><strong>Billing:</strong> Subscriptions are billed on a recurring basis (monthly or annually).</li>
        <li><strong>Cancellation:</strong> You may cancel at any time via your dashboard. Access remains active until the end of the current paid period.</li>
        <li><strong>Fair Use:</strong> We reserve the right to limit the number of "Verification Requests" per month if your usage significantly exceeds the average of our user base.</li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">5. Use Restrictions</h2>
      <p>You agree not to:</p>
      <ul className="list-disc ml-6 space-y-2">
        <li>Submit or encourage fraudulent, incentivized, or "fake" reviews.</li>
        <li>Use the service to harass, defame, or misrepresent competitors.</li>
        <li>Attempt to scrape the "Verified Registry Index" without authorization.</li>
      </ul>
    </section>
<section>
  <h2 className="text-xl font-bold text-black mb-4">6. Review Verification & "Proof of Service"</h2>
  <p>To maintain the integrity of our Registry, Sitemanifest employs a strict verification system:</p>
  <ul className="list-disc ml-6 space-y-2">
    <li><strong>Invited Reviews:</strong> Users invited via our secure email system are pre-verified via a digital token. No manual proof is required, subject to security audits.</li>
    <li><strong>Guest Reviews:</strong> Invited users may also choose to leave a review without logging in. These reviews are clearly labeled as <em>"Guest Review"</em> to ensure transparency.</li>
    <li><strong>Regular Reviews:</strong> Non-invited users must submit <strong>"Proof of Service"</strong> (e.g., a screenshot of a receipt, invoice, or agreement).</li>
    <li><strong>Audit Rights:</strong> Sitemanifest reserves the sole right to reject any review that fails to provide clear and authentic evidence of a business transaction.</li>
    <li><strong>Limitations:</strong> While our moderation process is strict and designed to detect manipulation, no system can guarantee 100% elimination of fraudulent reviews. However, Sitemanifest maintains one of the highest standards of review purity available.</li>
  </ul>
</section>


<section>
  <h2 className="text-xl font-bold text-black mb-4">7. Screenshot-to-Review Conversion</h2>
  <p>
    When a Business User uploads an image of a pre-existing testimonial (WhatsApp, Email, or Third-Party):
  </p>
  <ul className="list-disc ml-6 space-y-2">
    <li>The Business User warrants the screenshot represents a genuine communication from a real customer.</li>
    <li>Sitemanifest will verify the content and metadata. We reserve the right to decline any conversion that appears manipulated.</li>
    <li>All screenshot-to-review conversions are clearly labeled as "Converted" to ensure transparency for end users.</li>
    <li>The Business User is solely responsible for ensuring the customer is aware and has consented to the conversion of their testimonial into a review.</li>
    <li>Sitemanifest assumes no liability for disputes, claims, or issues arising from the Business User’s failure to obtain proper consent.</li>
  </ul>
</section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">8. Electronic Communications</h2>
      <p>
        By using our email invitation tools, the Business User warrants they have an 
        established relationship with the recipient and have the legal right to contact them. 
        All automated emails sent via Sitemanifest include a mandatory opt-out mechanism.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">9. Search Engine Disclaimer</h2>
      <p className="italic text-gray-600">
        Sitemanifest optimizes technical schema for Google indexing. We do not guarantee 
        specific rankings or the display of "Rich Snippet" stars, as these are controlled 
        entirely by third-party algorithms.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">10. Liability & Governing Law</h2>
      <p>
        Our total liability is limited to the amount paid for the service in the last 6 months. 
        These terms are governed by the laws of <strong>Georgia</strong>.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">11. Contact</h2>
      <p>Legal inquiries: <span className="text-[#3EBAA2] font-semibold">support@sitemanifest.com</span></p>
    </section>
  </LegalLayout>
);

export default Terms;